﻿import * as bootstrap from "bootstrap";
(window as any).bootstrap = bootstrap;

/* ======================================================
   GLOBAL STATE
   ====================================================== */

let suppressOffcanvasReload = false;


const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))